<template>
  <div class="menu">
    <!-- Section Lunch Menu -->

    <section id="new" class="padd-100 dark-bg">
      <h2 class="section-title sep-type-2 text-center">Actuellement</h2>
      <div class="container">
        <div class="row">
          <div class="menu-container">
            <div class="menu-item">
              <div class="col-md-6">
                <div v-for="(newPlate, index) in menuData.new" v-if="index < Math.ceil(menuData.new.length/2)" class="offer-item">
                  <div>
                    <h3>{{ newPlate.name }}</h3>
                    <p>{{ newPlate.ingredients }}</p>
                  </div>
                  <span class="offer-price">{{ newPlate.price }}</span>
                </div>
              </div>
              <div class="col-md-6">
                <div v-for="(newPlate, index) in menuData.new" v-if="index >= menuData.new.length/2" class="offer-item">
                  <div>
                    <h3>{{ newPlate.name }}</h3>
                    <p>{{ newPlate.ingredients }}</p>
                  </div>
                  <span class="offer-price">{{ newPlate.price }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section id="submenu">
      <div>
        <ul>
          <li class="active"><a onclick="$('html,body').animate({scrollTop: $('#pizza').offset().top},1500,'easeInOutQuad');">Pizzas</a></li>
          <li><a onclick="$('html,body').animate({scrollTop: $('#bruschette').offset().top},1500,'easeInOutQuad');">Bruschette</a></li>
          <li><a onclick="$('html,body').animate({scrollTop: $('#pasta').offset().top},1500,'easeInOutQuad');">Pâtes</a></li>
          <li><a onclick="$('html,body').animate({scrollTop: $('#risotto').offset().top},1500,'easeInOutQuad');">Risottos</a></li>
          <li><a onclick="$('html,body').animate({scrollTop: $('#salad').offset().top},1500,'easeInOutQuad');">Salades</a></li>
        </ul>
      </div>
    </section>

    <section id="pizza" class="padd-100">
      <h2 class="section-title sep-type-2 text-center">Pizzas</h2>
      <div class="container">
        <div class="row">
          <div class="menu-container">
            <div class="menu-item">
              <div class="col-md-6">
                <div v-for="(pizza, index) in menuData.pizzas" v-if="index < Math.ceil(menuData.pizzas.length/2)" class="offer-item">
                  <div>
                    <h3>{{ pizza.name }}</h3>
                    <p>{{ pizza.ingredients }}</p>
                  </div>
                  <span class="offer-price">{{ pizza.price }}</span>
                </div>
              </div>
              <div class="col-md-6">
                <div v-for="(pizza, index) in menuData.pizzas" v-if="index >= menuData.pizzas.length/2" class="offer-item">
                  <div>
                    <h3>{{ pizza.name }}</h3>
                    <p>{{ pizza.ingredients }}</p>
                  </div>
                  <span class="offer-price">{{ pizza.price }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End Section Lunch Menu -->

    <section id="submenu">
      <div>
        <ul>
          <li><a onclick="$('html,body').animate({scrollTop: $('#pizza').offset().top},1500,'easeInOutQuad');">Pizzas</a></li>
          <li class="active"><a onclick="$('html,body').animate({scrollTop: $('#bruschette').offset().top},1500,'easeInOutQuad');">Bruschette</a></li>
          <li><a onclick="$('html,body').animate({scrollTop: $('#pasta').offset().top},1500,'easeInOutQuad');">Pâtes</a></li>
          <li><a onclick="$('html,body').animate({scrollTop: $('#risotto').offset().top},1500,'easeInOutQuad');">Risottos</a></li>
          <li><a onclick="$('html,body').animate({scrollTop: $('#salad').offset().top},1500,'easeInOutQuad');">Salades</a></li>
        </ul>
      </div>
    </section>

    <!-- Section Appetizer -->
    <section id="bruschette" class="padd-100 dark-bg">
      <h2 class="section-title sep-type-2 text-center">Bruschette</h2>
      <div class="container">
        <div class="row">
          <div class="menu-container">
            <div class="menu-item">
              <div class="col-md-6">
                <div v-for="(bruschetta, index) in menuData.bruschette" v-if="index < Math.ceil(menuData.bruschette.length/2)" class="offer-item">
                  <div>
                    <h3>{{ bruschetta.name }}</h3>
                    <p>{{ bruschetta.ingredients }}</p>
                  </div>
                  <span class="offer-price">{{ bruschetta.price }}</span>
                </div>
              </div>
              <div class="col-md-6">
                <div v-for="(bruschetta, index) in menuData.bruschette" v-if="index >= menuData.bruschette.length/2" class="offer-item">
                  <div>
                    <h3>{{ bruschetta.name }}</h3>
                    <p>{{ bruschetta.ingredients }}</p>
                  </div>
                  <span class="offer-price">{{ bruschetta.price }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End Section Appetizer -->

    <section id="submenu">
      <div>
        <ul>
          <li><a onclick="$('html,body').animate({scrollTop: $('#pizza').offset().top},1500,'easeInOutQuad');">Pizzas</a></li>
          <li><a onclick="$('html,body').animate({scrollTop: $('#bruschette').offset().top},1500,'easeInOutQuad');">Bruschette</a></li>
          <li class="active"><a onclick="$('html,body').animate({scrollTop: $('#pasta').offset().top},1500,'easeInOutQuad');">Pâtes</a></li>
          <li><a onclick="$('html,body').animate({scrollTop: $('#risotto').offset().top},1500,'easeInOutQuad');">Risottos</a></li>
          <li><a onclick="$('html,body').animate({scrollTop: $('#salad').offset().top},1500,'easeInOutQuad');">Salades</a></li>
        </ul>
      </div>
    </section>

    <!-- Section Main Course -->
    <section id="pasta" class="padd-100">
      <h2 class="section-title sep-type-2 text-center">Pâtes</h2>
      <span class="section-suptitle text-center">Spaghetti • Penne • Rigatoni • Orecchiette • Tagliatelle</span>
      <div class="container">
        <div class="row">
          <div class="menu-container">
            <div class="menu-item">
              <div class="col-md-6">
                <div v-for="(pate, index) in menuData.pates" v-if="index < Math.ceil(menuData.pates.length/2)" class="offer-item">
                  <div>
                    <h3>{{ pate.name }}</h3>
                    <p>{{ pate.ingredients }}</p>
                  </div>
                  <span class="offer-price">{{ pate.price }}</span>
                </div>
              </div>
              <div class="col-md-6">
                <div v-for="(pate, index) in menuData.pates" v-if="index >= menuData.pates.length/2" class="offer-item">
                  <div>
                    <h3>{{ pate.name }}</h3>
                    <p>{{ pate.ingredients }}</p>
                  </div>
                  <span class="offer-price">{{ pate.price }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End Section Main Course -->

    <!-- Section Main Course -->
    <section id="home-pasta" class="padd-100 dark-bg">
      <h2 class="section-title sep-type-2 text-center">Pâtes maison</h2>
      <div class="container">
        <div class="row">
          <div class="menu-container">
            <div class="menu-item">
              <div class="col-md-6">
                <div v-for="(pate, index) in menuData.patesmaison" v-if="index < Math.ceil(menuData.patesmaison.length/2)" class="offer-item">
                  <div>
                    <h3>{{ pate.name }}</h3>
                    <p>{{ pate.ingredients }}</p>
                  </div>
                  <span class="offer-price">{{ pate.price }}</span>
                </div>
              </div>
              <div class="col-md-6">
                <div v-for="(pate, index) in menuData.patesmaison" v-if="index >= menuData.patesmaison.length/2" class="offer-item">
                  <div>
                    <h3>{{ pate.name }}</h3>
                    <p>{{ pate.ingredients }}</p>
                  </div>
                  <span class="offer-price">{{ pate.price }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End Section Main Course -->

   <section id="submenu">
      <div>
        <ul>
          <li><a onclick="$('html,body').animate({scrollTop: $('#pizza').offset().top},1500,'easeInOutQuad');">Pizzas</a></li>
          <li><a onclick="$('html,body').animate({scrollTop: $('#bruschette').offset().top},1500,'easeInOutQuad');">Bruschette</a></li>
          <li><a onclick="$('html,body').animate({scrollTop: $('#pasta').offset().top},1500,'easeInOutQuad');">Pâtes</a></li>
          <li class="active"><a onclick="$('html,body').animate({scrollTop: $('#risotto').offset().top},1500,'easeInOutQuad');">Risottos</a></li>
          <li><a onclick="$('html,body').animate({scrollTop: $('#salad').offset().top},1500,'easeInOutQuad');">Salades</a></li>
        </ul>
      </div>
    </section>

    <section id="risotto" class="padd-100">
      <h2 class="section-title sep-type-2 text-center">Risottos</h2>
      <div class="container">
        <div class="row">
          <div class="menu-container">
            <div class="menu-item">
              <div class="col-md-6">
                <div v-for="(risotto, index) in menuData.risottos" v-if="index < Math.ceil(menuData.risottos.length/2)" class="offer-item">
                  <div>
                    <h3>{{ risotto.name }}</h3>
                    <p>{{ risotto.ingredients }}</p>
                  </div>
                  <span class="offer-price">{{ risotto.price }}</span>
                </div>
              </div>
              <div class="col-md-6">
                <div v-for="(risotto, index) in menuData.risottos" v-if="index >= menuData.risottos.length/2" class="offer-item">
                  <div>
                    <h3>{{ risotto.name }}</h3>
                    <p>{{ risotto.ingredients }}</p>
                  </div>
                  <span class="offer-price">{{ risotto.price }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section id="submenu">
      <div>
        <ul>
          <li><a onclick="$('html,body').animate({scrollTop: $('#pizza').offset().top},1500,'easeInOutQuad');">Pizzas</a></li>
          <li><a onclick="$('html,body').animate({scrollTop: $('#bruschette').offset().top},1500,'easeInOutQuad');">Bruschette</a></li>
          <li><a onclick="$('html,body').animate({scrollTop: $('#pasta').offset().top},1500,'easeInOutQuad');">Pâtes</a></li>
          <li><a onclick="$('html,body').animate({scrollTop: $('#risotto').offset().top},1500,'easeInOutQuad');">Risottos</a></li>
          <li class="active"><a onclick="$('html,body').animate({scrollTop: $('#salad').offset().top},1500,'easeInOutQuad');">Salades</a></li>
        </ul>
      </div>
    </section>

    <!-- Section Salad -->
    <section id="salad" class="padd-100 dark-bg">
      <h2 class="section-title sep-type-2 text-center">Salades</h2>
      <div class="container">
        <div class="row">
          <div class="menu-container">
            <div class="menu-item">
              <div class="col-md-6">
                <div class="offer-item">
                  <div>
                    <h3>&nbsp;</h3>
                    <p>&nbsp;</p>
                  </div>
                  <span class="offer-price"><i class="fa fa-circle" aria-hidden="true"></i></span>
                  <span class="offer-hprice"><i class="fa fa-adjust" aria-hidden="true"></i></span>
                </div>
                <div v-for="(salade, index) in menuData.salades" v-if="index < Math.ceil(menuData.salades.length/2)" class="offer-item">
                  <div>
                    <h3>{{ salade.name }}</h3>
                    <p>{{ salade.ingredients }}</p>
                  </div>
                  <span class="offer-price">{{ salade.price }}</span>
                  <span class="offer-hprice">{{ salade.hprice }}</span>
                </div>
              </div>
              <div class="col-md-6">
                <div class="offer-item second">
                  <div>
                    <h3>&nbsp;</h3>
                    <p>&nbsp;</p>
                  </div>
                  <span class="offer-price"><i class="fa fa-circle" aria-hidden="true"></i></span>
                  <span class="offer-hprice"><i class="fa fa-adjust" aria-hidden="true"></i></span>
                </div>
                <div v-for="(salade, index) in menuData.salades" v-if="index >= menuData.salades.length/2" class="offer-item">
                  <div>
                    <h3>{{ salade.name }}</h3>
                    <p>{{ salade.ingredients }}</p>
                  </div>
                  <span class="offer-price">{{ salade.price }}</span>
                  <span class="offer-hprice">{{ salade.hprice }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End Section Salad -->

    <section id="submenu">
      <div>
        <ul>
          <li><a onclick="$('html,body').animate({scrollTop: $('#pizza').offset().top},1500,'easeInOutQuad');">Pizzas</a></li>
          <li><a onclick="$('html,body').animate({scrollTop: $('#bruschette').offset().top},1500,'easeInOutQuad');">Bruschette</a></li>
          <li><a onclick="$('html,body').animate({scrollTop: $('#pasta').offset().top},1500,'easeInOutQuad');">Pâtes</a></li>
          <li><a onclick="$('html,body').animate({scrollTop: $('#risotto').offset().top},1500,'easeInOutQuad');">Risottos</a></li>
          <li><a onclick="$('html,body').animate({scrollTop: $('#salad').offset().top},1500,'easeInOutQuad');">Salades</a></li>
        </ul>
      </div>
    </section>

    <!-- Section Desserts -->
    <section id="desserts" class="padd-100">
      <h2 class="section-title sep-type-2 text-center">Desserts</h2>
      <div class="container">
        <div class="row">
          <div class="menu-container">
            <div class="menu-item">
              <div class="col-md-6">
                <div v-for="(dessert, index) in menuData.desserts" v-if="index < Math.ceil(menuData.desserts.length/2)" class="offer-item">
                  <div>
                    <h3>{{ dessert.name }}</h3>
                  </div>
                  <span class="offer-price">{{ dessert.price }}</span>
                </div>
              </div>
              <div class="col-md-6">
                <div v-for="(dessert, index) in menuData.desserts" v-if="index >= menuData.desserts.length/2" class="offer-item">
                  <div>
                    <h3>{{ dessert.name }}</h3>
                  </div>
                  <span class="offer-price">{{ dessert.price }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End Section Desserts -->

    <section v-if="!isMobile()" id="deco" data-background="static/img/bg/dessert.jpg" class="parallax-window"></section>

    <!-- Section Drink -->
    <section id="drink" class="padd-100">
      <div class="container">
        <div class="row">
          <div class="col-md-6">
            <span class="section-suptitle">Boissons</span>
            <h4 class="section-title">
              Bouteilles 5dl
            </h4>
            <div v-for="(boisson, index) in menuData.boissons.dl" class="drink-item">
              <span>{{ boisson.name }}</span>
              <p>{{ boisson.price }}</p>
            </div>
          </div>
          <div class="col-md-6">
            <span class="section-suptitle">Boissons</span>
            <h4 class="section-title">
              Canettes 33cl
            </h4>
            <div v-for="(boisson, index) in menuData.boissons.cl" class="drink-item">
              <span>{{ boisson.name }}</span>
              <p>{{ boisson.price }}</p>
            </div>
          </div>
          <div class="col-md-12">
            <span class="section-suptitle">Boissons</span>
            <h4 class="section-title">
              Bouteilles 1l
            </h4>
            <div v-for="(boisson, index) in menuData.boissons.l" class="drink-item">
              <span>{{ boisson.name }}</span>
              <p>{{ boisson.price }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End Section Drink -->
  </div>
</template>

<script>
  import menuData from '../data/menu.json';
export default {
  name: 'menu',
  data () {
    return {
      menuData: menuData,
      isMobile: function(a){ return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase())}
    }
  },
  mounted: function () {
    if(!this.isMobile()) {
      $('.parallax-window').each(function () {
        $(this).parallax($.extend(true, {
          lazyLoad: true,
          mode: 'parallax',
          speedFactor: 0.3
        }, $(this).data()));
      });
    }

    if($(window).scrollTop() > 100) {
      $('html,body').animate({scrollTop: 0}, 1500, 'easeInOutQuad');
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// Menu.vue?53b5c19f